import DailyStatsTableCard from 'components/DailyStatsTableCard';
import React from 'react';

import { useAdvertisersDashboard } from '../AdvertisersDashboardContext';
import columns, { defaultSort } from './utils';

const EpisodeLevelReportingCard: React.FunctionComponent = () => {
  const { episodeLevelStats } = useAdvertisersDashboard();

  return (
    <DailyStatsTableCard
      columns={columns}
      dailyStats={episodeLevelStats}
      defaultSort={defaultSort}
      showFooter={false}
      tableLayout="fixed"
      title="Episode-level reporting"
    />
  );
};

export default EpisodeLevelReportingCard;
